require("@yaireo/fakescroll/fakescroll.js");
require('@yaireo/fakescroll/fakescroll.css');
window.expertiseScroller.fakeScroll({
  //onChange: () => console.log(myScrollbar.scrollRatio)
});

//$(".expertises.k-group")[0].fakeScroll({
//    //onChange: () => console.log(myScrollbar.scrollRatio)
//})